import { Image } from "@components/Image/Image";
import React, { lazy, Suspense } from "react";
import tw, { styled } from "twin.macro";
import { withVideo } from "./withVideo";

const ReactPlayer = lazy(
  () => import(/* webpackChunkName: "react-player" */ "react-player"),
);

const VideoContainer = tw.div`
  w-full h-full relative
`;

const VideoPlayer = styled(ReactPlayer)`
  ${tw`absolute object-cover z-1`}
  video {
    object-fit: cover;
    object-position: center bottom;
  }
`;

export const Video = withVideo(({ playing, video, videoBackground, muted }) => (
  <VideoContainer data-testid="video-player">
    <Suspense fallback={<></>}>
      <VideoPlayer
        controls={false}
        loop={true}
        playing={playing}
        muted={muted}
        playsinline={true}
        url={video?.url}
        width="100%"
        height="100%"
      />
    </Suspense>
    <Image
      image={videoBackground}
      alt={videoBackground?.alt}
      data-testid="video-image-fallback"
    />
  </VideoContainer>
));
